import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { PageFooter } from '@zillow/page-frame';

import { setupOneTrustFooter } from './components/cookie-pref';

const Footer = ({ onLinkClick }) => {
  useEffect(() => setupOneTrustFooter(), []);
  return <PageFooter onLinkClick={onLinkClick} />;
};

Footer.propTypes = {
  onLinkClick: PropTypes.func,
};

Footer.defaultProps = {
  onLinkClick: () => {},
};

export default Footer;
